import type { App } from 'vue';

export * from './day';
export * from './utils/utils';

export const StuutUI = {
  install: (app: App) => {},
};
